
import { ReactNode, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from '@/lib/utils'

interface NavBarProps {
    children: ReactNode;
    mobileChildren: ReactNode;
    drawerOpen: boolean;
    className?: string;
    setDrawerOpen: (value: boolean) => void;
}

export default function NavBar({ children, mobileChildren, drawerOpen = false, className, setDrawerOpen }: NavBarProps) {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") setDrawerOpen(false);
        };
        if (drawerOpen) {
            document.body.style.overflow = "hidden";
            document.addEventListener("keydown", handleKeyDown);
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("keydown", handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen]);

    return (
        <>
            <motion.nav
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
                className={cn(
                    "sticky top-0 left-0 w-full h-16 sm:h-20 z-50 backdrop-blur-md bg-primary/75 shadow-sm",
                    className
                )}
            >
                {children}
            </motion.nav>
            <AnimatePresence>
                {drawerOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 0.5 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setDrawerOpen(false)}
                            className="fixed inset-0 bg-black dark:bg-white/10 z-40"
                        />
                        <motion.div
                            initial={{ x: "100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "100%" }}
                            transition={{ type: "tween", duration: 0.3 }}
                            className="fixed top-0 right-0 w-64 h-full backdrop-blur-xl dark:bg-zinc-900 z-50"
                        >
                            <div className="shadow-lg flex flex-col bg-primary/20 h-full w-full">
                                {mobileChildren}
                            </div>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </>
    )
}
